import { useEffect, useRef, useState } from 'react';

const useStableOnlineStatus = (delayMs = 2500) => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const timeoutRef = useRef(null);

  useEffect(() => {
    const handleOnline = () => {
      clearTimeout(timeoutRef.current);
      setIsOnline(true);
    };

    const handleOffline = () => {
      timeoutRef.current = setTimeout(() => {
        setIsOnline(false);
      }, delayMs);
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
      clearTimeout(timeoutRef.current);
    };
  }, [delayMs]);

  return isOnline;
};

export default useStableOnlineStatus;
